
import type { RouteObject } from "react-router-dom";
import Splash from "../pages/splash/page";
import Login from "../pages/login/page";
import Home from "../pages/home/page";
import Services from "../pages/services/page";
import ServiceDetail from "../pages/service-detail/page";
import PriceOffers from "../pages/price-offers/page";
import OrderTracking from "../pages/order-tracking/page";
import Orders from "../pages/orders/page";
import Payment from "../pages/payment/page";
import Rating from "../pages/rating/page";
import Profile from "../pages/profile/page";
import Location from "../pages/location/page";
import Wallet from "../pages/wallet/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Splash />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/service/:id",
    element: <ServiceDetail />,
  },
  {
    path: "/price-offers",
    element: <PriceOffers />,
  },
  {
    path: "/order-tracking",
    element: <OrderTracking />,
  },
  {
    path: "/orders",
    element: <Orders />,
  },
  {
    path: "/payment",
    element: <Payment />,
  },
  {
    path: "/rating",
    element: <Rating />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/location",
    element: <Location />,
  },
  {
    path: "/wallet",
    element: <Wallet />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
